module.exports = __webpack_public_path__ + "static/img/guidance1.76b1a7c7.webp";